import { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from '../../hooks/redux'
import { Modal } from '../../components/modal/modal'
import { Checkbox } from '../../components/checkbox/checkbox'
import { CustomButton } from '../../components/customButton'
import { OutClick } from '../../components/outClick'
import { updateVoiceGroup } from '../../store/slices/voiceGroups/async'
import { TGroup } from './groupsTab'
import { pluralVoices } from '../../functions'
import classes from '../../styles/voices/groupAccessModal.module.scss'

interface GroupAccessModalProps {
  group: TGroup
  onClose: () => void
}

export const GroupAccessModal: FC<GroupAccessModalProps> = ({ group, onClose }) => {
  const dispatch = useDispatch()
  const users = useSelector((state) => state.user.users)
  const [selected, setSelected] = useState<number[]>(() => group.users.map((u) => u.user_id))
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')

  const toggle = (userId: number) => {
    setSelected((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    )
  }

  const filteredUsers = users.filter((u) => !u.access_admin && u.auth_username.toLowerCase().includes(search.toLowerCase()))
  const allFilteredSelected = filteredUsers.length > 0 && filteredUsers.every((u) => selected.includes(u.user_id))

  const toggleAll = () => {
    if (allFilteredSelected) {
      setSelected((prev) => prev.filter((id) => !filteredUsers.some((u) => u.user_id === id)))
    } else {
      setSelected((prev) => [...new Set([...prev, ...filteredUsers.map((u) => u.user_id)])])
    }
  }

  const selectedLabels = users.filter((u) => !u.access_admin && selected.includes(u.user_id)).map((u) => u.auth_username).join(', ')

  return (
    <Modal isOpen title="Доступ к группе" handleClose={onClose} classes={{ modalContent: classes.modal }}>
      <div className={classes.wrapper}>
        <div className={classes.groupHeader}>
          <span className={classes.groupName}>{group.name}</span>
          <span className={classes.groupCount}>{pluralVoices(group.count)}</span>
        </div>

        <OutClick className={classes.dropdown} onClick={() => setOpen(false)}>
          <>
            <div
              className={classes.inputWrap}
              onClick={() => setOpen((p) => !p)}
            >
              <input
                className={classes.input}
                placeholder="Введите имя пользователя"
                value={open ? search : selectedLabels}
                onChange={(e) => { e.stopPropagation(); setSearch(e.target.value) }}
                onClick={(e) => e.stopPropagation()}
                onFocus={() => { setOpen(true); setSearch('') }}
                readOnly={!open}
                autoComplete="off"
              />
            </div>
            {open && (
              <div className={classes.userList}>
                <div
                  className={`${classes.userItem} ${classes.userItemSelectAll} ${allFilteredSelected ? classes.userItemSelected : ''}`}
                  onMouseDown={(e) => { e.preventDefault(); toggleAll() }}
                >
                  <Checkbox isChecked={allFilteredSelected} handleCheckboxChange={() => {}} />
                  <span className={classes.userName}>Выбрать все</span>
                </div>
                {filteredUsers.map((user) => (
                  <div
                    key={user.user_id}
                    className={`${classes.userItem} ${selected.includes(user.user_id) ? classes.userItemSelected : ''}`}
                    onMouseDown={(e) => { e.preventDefault(); toggle(user.user_id) }}
                  >
                    <Checkbox
                      isChecked={selected.includes(user.user_id)}
                      handleCheckboxChange={() => {}}
                    />
                    <span className={classes.userName}>{user.auth_username}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        </OutClick>
        <div className={classes.footer}>
          <CustomButton className={classes.footerCancel} onClick={onClose}>Отменить</CustomButton>
          <CustomButton
            className={classes.footerApply}
            onClick={() => {
              const usersPayload = users
                .filter((u) => selected.includes(u.user_id))
                .map((u) => ({ user_id: u.user_id, username: u.auth_username }))
              dispatch(updateVoiceGroup({ voice_group_id: Number(group.value), users: usersPayload }) as any)
              onClose()
            }}
          >
            Применить
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}
